import React, { useState, useEffect } from "react";
import Header from "../layouts/Employee/Header";
import SubHeader from "../layouts/Employee/SubHeader";
import "./OvertimeApplication.css";
import OvertimeStatus from "./OvertimeStatus";
import BusinessApplicationLayout from "../layouts/Employee/BusinessAplicationLayout";

function BusinessApplication() {
  return (
    <div className="overtime-application-bg">
      <Header />
      <SubHeader />
      <BusinessApplicationLayout />
    </div>
  );
}

export default BusinessApplication;
